import { useEffect, useState } from "react";
import FocusLock from "react-focus-lock";
import { TfaMethod } from "@/core/constants/tfaMethod";
import { Button, Icon, TextInput, ValidateCode } from "@/shared/ui";

type Props = {
  address: string;
  onSubmit: () => void;
  code: string;
  onChangeCode: (value: string) => void;
  onSendCode: () => void;
  pending: boolean;
  sendIsPending: boolean;
  email: string;
  onChangeEmail: (value: string) => void;
  error?: string;
  timer?: number;
};

export default function PlayerMenuSettingsSafetyConfirmChangingEmail({
  address,
  onSubmit,
  code,
  onChangeCode,
  onSendCode,
  pending,
  sendIsPending,
  onChangeEmail,
  email,
  error = "",
  timer,
}: Props) {
  const [touch, setTouch] = useState(false);

  useEffect(() => {
    if (!touch && email.length) {
      setTouch(true);
    }
  }, [email, touch]);

  return (
    <FocusLock className="contents">
      <form
        className="gap-3 grow flex flex-col h-full"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <div className="flex flex-col gap-5">
          <ValidateCode
            address={address}
            type={TfaMethod.EMAIL}
            title="Введите проверочный код, отправленный вам почту"
            code={code}
            onCodeChange={onChangeCode}
            onSendCode={onSendCode}
            pending={pending}
            onSubmit={() => {}}
            sendCodePending={sendIsPending}
            showSubmitButton={false}
            autoSubmit={false}
            timer={timer}
          />
          <div>
            <div className="text-white text-15 font-medium">Введите новый Email адрес</div>
            <div className="text-white/60 text-15 font-medium mt-1">
              Отправим PIN-код подтверждения на почту
            </div>
            <TextInput
              type="text"
              placeholder="Введите Email"
              value={email}
              icon={<Icon name="mail" className="w-4.5" />}
              invalid={touch && !email ? "Введите почту" : ""}
              onChange={onChangeEmail}
              className="text-center mt-2.5"
            />
          </div>
        </div>
        <div className="mt-auto grid gap-2.5">
          {!!error && <div className="alert alert--danger">*{error}</div>}
          <Button submit onSubmit={onSubmit} loading={pending} disabled={pending || !email}>
            Подтвердить
          </Button>
        </div>
      </form>
    </FocusLock>
  );
}
